import React from 'react';

const PasswordRequirements = ({ password, className = '' }) => {
  const requirements = [
    {
      text: 'At least 8 characters long',
      met: password.length >= 8,
    },
    {
      text: 'Contains at least one uppercase letter',
      met: /[A-Z]/.test(password),
    },
    {
      text: 'Contains at least one lowercase letter',
      met: /[a-z]/.test(password),
    },
    {
      text: 'Contains at least one number',
      met: /[0-9]/.test(password),
    },
    {
      text: 'Contains at least one special character (!@#$%^&*)',
      met: /[!@#$%^&*]/.test(password),
    },
  ];

  return (
    <div className={`text-sm space-y-1 ${className}`}>
      <p className="font-medium text-gray-700">Password Requirements:</p>
      <ul className="space-y-1">
        {requirements.map((req, index) => (
          <li
            key={index}
            className={`flex items-center space-x-2 ${
              req.met ? 'text-green-600' : 'text-gray-500'
            }`}
          >
            {req.met ? (
              <svg
                className="h-4 w-4"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M5 13l4 4L19 7" />
              </svg>
            ) : (
              <svg
                className="h-4 w-4"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M12 12h.01M12 12h.01M12 12h.01" />
              </svg>
            )}
            <span>{req.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRequirements;
